import React, { Component } from 'react';
import { graphql } from 'gatsby';
import {
  HomeSlider,
  PostcardForm,
  Layout,
  SliceZone,
} from '../components';
import './index.scss';

class Index extends Component {
  render() {
    const {
      data: {
        site: {
          siteMetadata,
        },
        page: {
          data: pageData,
        },
      },
      location,
    } = this.props;
    const {
      homeSlider,
      body,
      metaTitle,
      metaDescription,
      openGraphImage,
    } = pageData;
    const seoData = {
      metaTitle,
      metaDescription,
      openGraphImage,
    };
    return (
      <Layout location={location} seoData={seoData}>
        <HomeSlider
          items={homeSlider}
          siteMetadata={siteMetadata}
        />
        <SliceZone allSlices={body} siteMetadata={siteMetadata} />
        <PostcardForm
          title="Get in touch"
          formName="contact-form-home"
        />
      </Layout>
    );
  }
}

export default Index;

export const pageQuery = graphql`
query IndexQuery {
  site {
    siteMetadata {
      storiesSlug,
      categorySlug,
    }
  },
  page: prismicHome {
    uid,
    data {
      homeSlider: home_slider {
        photo {
          alt
          localFile {
            childImageSharp {
              fluid(maxWidth: 1600, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        story {
          slug: uid
          document {
            data {
              location {
                html
                text
              }
              storyTitle: page_name {
                html
                text
              }
            }
          }
        }
      }
      body {
        ... on PrismicHomeBodyCallToActionBlock {
          slice_type
          id
          primary {
            image {
              alt
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1000, quality: 90) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            title {
              html
              text
            }
            textBody: text_body {
              html
              text
            }
            buttonLabel: button_label {
              html
              text
            }
            link {
              type
              slug
            }
          }
        }
        ... on PrismicHomeBodyServicesBlock {
          slice_type
          id
          primary {
            headline {
              html
              text
            }
          }
          items {
            service {
              slug: uid
              document {
                data {
                  categoryName: category_name {
                    html
                    text
                  }
                  categoryDescription: category_description {
                    html
                    text
                  }
                  featuredImage: featured_image {
                    alt
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 800, quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        ... on PrismicHomeBodyFeaturedStoriesBlock {
          slice_type
          id
          primary {
            headline {
              html
              text
            }
          }
          items {
            featuredStory: featured_story {
              slug: uid
              document {
                data {
                  storyName: page_name {
                    html
                    text
                  }
                  narrative {
                    html
                    text
                  }
                  featuredImage: featured_image {
                    alt
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 800, quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      metaTitle: meta_title {
        html
        text
      },
      metaDescription: meta_description {
        html
        text
      },
      openGraphImage: open_graph_image {
        alt
        copyright
        url
      }
    }
  }
}
`;
